<template>
  <div class="home">
	  <section class="hero is-dark">
	    <div class="hero-body">
	     
	      
	       <div class="container" v-if="$auth.isAuthenticated">
	        <h1 class="title">
	          Welcome {{$auth.user.name}}
	        </h1>

			<div v-if="loading == true || loading_user == true">
				<div class="notification is-warning">
				Loading tasks ...
				</div>
			</div>

			<div v-if="loading == false && loading_user == false">
					
					<div class="columns" v-if="user.user_ireland == 1">
						<div class="column is-3">
							<a :href="ASP_SYSTEM_URL"><button class="button is-large is-fullwidth is-danger">Back to Red/Blue System</button></a>
							
						</div>
						<div class="column is-3">
							<router-link to="/orders/order-search/"><button class="button is-large is-fullwidth is-danger">Search/View an Order</button></router-link>
						</div>
						
						
					</div>
					
					<div v-if="task_allowed('digital_print_data_input') || task_allowed('printed_garments_incoming') || task_allowed('offshore_print_overview') || task_allowed('printing_cutting_overview') || task_allowed('makeup_overview') || task_allowed('makeup_data_input')">
						<h2 class="subtitle">
						Digital Print and Makeup
						</h2>

						<div class="columns">
							
							<div class="column is-3" v-if="task_allowed('printed_garments_incoming')" >
								<router-link to="/digitalprint/dashboard"><button class="button is-large is-fullwidth is-info">Artwork - Digital Print</button></router-link>
							</div>

							<div class="column is-3" v-if="task_allowed('printing_cutting_overview')">
								<router-link to="/printing-cutting/overview"><button class="button is-large is-fullwidth is-info">Printing/Cutting</button></router-link>
							</div>
							
							<div class="column is-3" v-if="task_allowed('makeup_overview')" >
								<router-link to="/makeup/overview"><button class="button is-large is-fullwidth is-info">Makeup Overview</button></router-link>
							</div>

							<div class="column is-3" v-if="task_allowed('makeup_data_input')" >
								<router-link to="/makeup/data-input"><button class="button is-large is-fullwidth is-info">Data Input</button></router-link>
							</div>

							
						</div>
						<div class="columns">
							
							<div class="column is-3" v-if="task_allowed('offshore_print_overview')" >
								<router-link to="/offshore-print/overview"><button class="button is-large is-fullwidth is-info">Offshore Print Overview</button></router-link>
							</div>
							<div class="column is-3" v-if="task_allowed('digital_print_data_input')" >
								<router-link to="/printing-cutting/data-input"><button class="button is-large is-fullwidth is-info">Digital Print - Scanning</button></router-link>
							</div>

							

							
						</div>
					</div>

					<div v-if="task_allowed('cut_sew_personalisation')">
						<br />
						<h2 class="subtitle" >
							Personalisation
						</h2>
						<div class="columns" >
							<div class="column is-3">
								<router-link to="/embroidery/personalisation"><button class="button is-large is-fullwidth is-primary">Personalisation Orders</button></router-link>
							</div>
							
						</div>
					</div>
					
					<div v-if="task_allowed('production_orders') || task_allowed('open_orders')">
						<br />
						<h2 class="subtitle" >
							Production
						</h2>
						<div class="columns" >
							<div class="column is-3" v-if="task_allowed('open_orders')">
								<router-link to="/production/open-orders-2"><button class="button is-large is-fullwidth is-warning">Open Orders Report</button></router-link>
							</div>
							<div class="column is-3" >
								<router-link to="/production/incoming-orders"><button class="button is-large is-fullwidth is-warning">Incoming Orders</button></router-link>
							</div>
						</div>
					</div>

					<div v-if="task_allowed('offshore_cut_sew_scanning') || task_allowed('offshore_orders') || task_allowed('offshore_makeup') || task_allowed('offshore_incoming_orders') || task_allowed('garment_admin') || task_allowed('cutting_overview') || task_allowed('cutting_planner') || task_allowed('printing_planner') || task_allowed('offshore_embroidery') || task_allowed('offshore_embroidery_report') || task_allowed('knitted_trims_admin') ">
						<br />
						<h2 class="subtitle" >
							OffShore
						</h2>
						<div class="columns" >
							<div class="column is-3" v-if="task_allowed('offshore_orders')">
								<router-link to="/offshore/orders"><button class="button is-large is-fullwidth is-success">Offshore Orders</button></router-link>
							</div>
							<div class="column is-3" v-if="task_allowed('offshore_makeup')">
								<router-link to="/offshore/makeup"><button class="button is-large is-fullwidth is-success">Offshore Makeup</button></router-link>
							</div>
							<div class="column is-3" v-if="task_allowed('offshore_cut_sew_scanning')" >
								<router-link to="/cut-sew/data-input"><button class="button is-large is-fullwidth is-success">Scanning for C/S and P/P</button></router-link>
							</div>
						</div>
						<div class="columns" >
							<div class="column is-3" v-if="task_allowed('cutsew_incoming_orders')">
								<router-link to="/cut-sew/incoming-orders"><button class="button is-large is-fullwidth is-success">Cut/Sew Incoming Orders</button></router-link>
							</div>
							<div class="column is-3" v-if="task_allowed('cutting_overview')">
								<router-link to="/cut-sew/cutting-overview"><button class="button is-large is-fullwidth is-success">Cutting Overview</button></router-link>
							</div>
							<div class="column is-3" v-if="task_allowed('garment_admin')">
								<router-link to="/production/garment-admin"><button class="button is-large is-fullwidth is-success">Garment Admin</button></router-link>
							</div>
						</div>
						<div class="columns" >
							<div class="column is-3" v-if="task_allowed('trexcode_admin')">
								<router-link to="/production/trexcode-admin"><button class="button is-large is-fullwidth is-success">Trex Code Admin</button></router-link>
							</div>
							<div class="column is-3" v-if="task_allowed('offshore_embroidery')">
								<router-link to="/offshore/embroidery-inprogress"><button class="button is-large is-fullwidth is-success">Offshore Embroidery</button></router-link>
							</div>
							<div class="column is-3" v-else-if="task_allowed('offshore_embroidery_report')">
								<router-link to="/offshore/embroidery-report"><button class="button is-large is-fullwidth is-success">Embroidery Report</button></router-link>
							</div>
							<div class="column is-3" v-if="task_allowed('garment_admin')">
								
							</div>
						</div>
						<div class="columns" >
							<div class="column is-3" v-if="task_allowed('cutting_planner')">
								<router-link to="/cut-sew/cutting-planner"><button class="button is-large is-fullwidth is-success">Cutting Planner</button></router-link>
							</div>
							<div class="column is-3" v-if="task_allowed('printing_planner')">
								<router-link to="/printing-cutting/planner"><button class="button is-large is-fullwidth is-success">Print Planner</button></router-link>
							</div>
							<div class="column is-3" v-if="task_allowed('offshore_printing_planner')">
								<router-link to="/offshore/planner"><button class="button is-large is-fullwidth is-success">Offshore Print Planner</button></router-link>
							</div>
							<div class="column is-3" v-if="task_allowed('knitted_trims_admin')">
								<router-link to="/production/knitted-trims"><button class="button is-large is-fullwidth is-success">Knitted Trims</button></router-link>
							</div>
						</div>
					</div>

					<div v-if="task_allowed('report_orders_short_turnaround') || task_allowed('report_orders_short_turnaround') ">
						<br />
						<h2 class="subtitle" >
							Reports
						</h2>
						<div class="columns" >
							<div class="column is-3" v-if="task_allowed('report_orders_short_turnaround')">
								<router-link to="/reports/orders-short-delivery"><button class="button is-large is-fullwidth is-link">Short Turnaround Orders</button></router-link>
							</div>

							<div class="column is-3" v-if="task_allowed('report_made_up_offshore')">
								<router-link to="/reports/made-up-offshore"><button class="button is-large is-fullwidth is-link">Orders Made Up Offshore</button></router-link>
							</div>
							
						</div>
					</div>

					<div v-if="task_allowed('view_my_samples') || task_allowed('samples_admin') || task_allowed('samples_artwork')">
						<br />
						<h2 class="subtitle" >
							Samples
						</h2>
						<div class="columns" >
							<div class="column is-3" v-if="task_allowed('samples_artwork')">
								<router-link to="/samples/list-samples/new"><button class="button is-large is-fullwidth is-link">New Requests (Artwork)</button></router-link>
							</div>
							<div class="column is-3" v-if="task_allowed('view_my_samples')">
								<router-link to="/samples/list-samples/mysamples"><button class="button is-large is-fullwidth is-link">My Samples</button></router-link>
							</div>
							<div class="column is-3" v-if="task_allowed('view_my_samples')">
								<router-link to="/samples/new-request"><button class="button is-large is-fullwidth is-link">Start New Sample Request</button></router-link>
							</div>
						</div>
					</div>

					
	       
	      		</div>
			</div>
	    </div>
	    
	  </section>
	  
	</div>
</template>

<script>
//import UserService from '@/services/UserService.js';
import OrderMixin from "@/mixins/OrderMixin.js";


export default {
 
 name: 'Home',
  data: function() {
	  return {
		  ASP_SYSTEM_URL: process.env.VUE_APP_ASP_URL,
		  user: {tasks: []},
		  loading: false,
		  loading_user: true
	  }
  },
  mixins: [OrderMixin],
 	methods: {
	  // Log the user in
	  login() {
	    this.$auth.loginWithRedirect();
	  },
	  
	  
	},
	created() {
		this.getAccessToken()
        .then(() => { 
           this.getUserProfile(1); // 1 for with_tasks
        });

		
	}
}

</script>
